import * as React from 'react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text12 from '@sdk/components/ui/typography/Text12';

import type { SpecialGroupType } from '../types/GroupsArrayType';
import Padding from '../ui/Padding';
import FlexRow from '../ui/FlexRow';

import { UNASSIGNED, AVAILABLE } from './constants';

function getThemeColor(type: string): ThemeColorType {
  if (type === UNASSIGNED) {
    return ThemeColorType.primary;
  }

  if (type === AVAILABLE) {
    return ThemeColorType.success;
  }

  return ThemeColorType.gray;
}

type Props = {
  type?: SpecialGroupType;
  text: string;
  color?: string;
};
const HeaderTextRow: React.FC<React.PropsWithChildren<Props>> = ({ text, type, color }: Props) => {
  return (
    <Padding bottom={10} top={20}>
      <FlexRow>{getText(text, type, color)}</FlexRow>
    </Padding>
  );
};

function getText(text: string, type: SpecialGroupType, color?: string): JSX.Element {
  if (color) {
    return (
      <Text12 uppercase bold color={color}>
        {text}
      </Text12>
    );
  }

  const themeColor = getThemeColor(type);
  return (
    <Text12 uppercase bold themeColor={themeColor}>
      {text}
    </Text12>
  );
}

export default HeaderTextRow;
